import { BASE_BORDER_RADIUS } from 'styles/Base';
import { NAVY, SHADOWS } from 'styles/Colors';
import { SET_DATA, SET_ERROR } from 'helpers/Constants';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from 'components/forms/Checkbox';
import React from 'react';

const containerStyle = {
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: NAVY,
  borderRadius: BASE_BORDER_RADIUS,
  h3: {
    backgroundColor: NAVY,
    fontWeight: 'normal'
  }
};

const checkboxStyle = {
  boxShadow: `0 -4px 8px ${SHADOWS}`,
  maxHeight: '25rem',
  padding: '1rem',
  opacity: 1
};

const contentStyle = {
  height: '10rem',
  overflow: 'scroll',
  padding: '1rem'
};

function TextWithCheckbox({
  body,
  checkBoxLabel,
  header,
  id,
  name,
  additionalStyle = {}
}) {
  const value = useSelector((state) => state[id]);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    dispatch({
      type: SET_DATA,
      payload: { [id]: e.target.checked }
    });
    dispatch({
      type: SET_ERROR,
      payload: { [id]: !e.target.checked }
    });
  };
  return (
    <div
      css={[containerStyle, additionalStyle.containerStyle]}
      data-testid={id}
    >
      {header}
      <div css={[contentStyle, additionalStyle.contentStyle]}>{body}</div>
      <div css={[checkboxStyle, additionalStyle.checkboxStyle]}>
        <Checkbox
          id={id}
          label={checkBoxLabel}
          name={name}
          onChange={handleChange}
          value={value}
        />
      </div>
    </div>
  );
}

export default TextWithCheckbox;
